import { useEffect, useState } from "react"
import GenericBody from "../Componentes/GenericBody"
import NavBar from "../Componentes/NavBar"
import OrganogramaContainer from "../Componentes/OrganogramaContainer"
import SmallLoading from "../Componentes/Utils/SmallLoading"
import styled from "styled-components"
import useApi from "../hooks/useApi"

const ModalError = styled.div`
    width: 550px;
    background-color: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border: 2px solid #ff1a1a;
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: 20px;
    box-sizing: border-box;
    h3{
        text-align: center;
        font-size: 18px;
        color: #ff1a1a;
        font-weight: bold;
    }
    p{
        text-align: center;
        font-size: 14px;
        color: #333333;
    }
    ul{
        margin: 10px 0;
        li{
            font-size: 14px;
            color: #333333;
            margin-bottom: 5px;
        }
    }
`

const ColabsOrg = () => {
    const api = useApi();

    const [ colabs, setColabs ] = useState([])

    const [ loading, setLoading ] = useState( false )
    const [ error, setError ] = useState( false )
    const [ verificado, setVerificado ] = useState( false )

    const [ inconsistencias, setInconsistencias ] = useState([])

    const getColabs = async () => {

        setLoading( true );
        setVerificado( false );

        try{

            const { data } = await api.get('/Painel/API/OrganogramaColabs/')
            console.log( data )
            setColabs( data )

        }catch( e ){

            console.error( e )
            setError( true )

        }finally{

            setLoading( false );
            
        }

    }

    useEffect(() => {

        getColabs();

    }, [])



    const verificarHierarquia = () => {

        const grafo = new Map();
        const resultado = [];
        const visitadosGlobal = new Set();
    
        colabs.forEach(({ id, parentId }) => {
          if (id && parentId) grafo.set(id, parentId);
        });
    
        const dfs = (id, visitadosLocais = new Set()) => {
          if (visitadosLocais.has(id)) return id;
          if (visitadosGlobal.has(id)) return null;
    
          visitadosLocais.add(id);
          visitadosGlobal.add(id);
    
          const parentId = grafo.get(id);
          if (parentId) return dfs(parentId, new Set(visitadosLocais));
    
          return null;
        };
    
        for (const c of colabs) {
          const idCiclo = dfs(c.id);
          if (idCiclo && !resultado.find(r => r.id === idCiclo)) {
            const dados = colabs.find(c => c.id === idCiclo);
            if (dados) {
              resultado.push({
                id: dados.id,
                centro_custo: dados.centro_custo
              });
            }
          }
        }

        console.log( resultado );
    
        setInconsistencias(resultado);
        setVerificado(true);

        return resultado.length === 0;

    };

    useEffect(() => {

        if (colabs.length > 0 && !loading ) {

            verificarHierarquia();

        }

    }, [ colabs, loading ]);

    return(
        <>
            <NavBar title="ORGANOGRAMA DE COLABORADORES" />
            <GenericBody>
                {
                    loading ? (
                        <SmallLoading />
                    ) : error ? (
                        <p>Erro ao buscar informações. Tente novamente</p>
                    ) : !verificado ? (
                        <SmallLoading />
                    ) : verificado && inconsistencias.length > 0 ? (
                        <ModalError>
                            <h3>Inconsistências encontradas</h3>
                            <p>Foram encontrados ciclos na hierarquia dos colaboradores. Por favor, verifique os dados.</p>
                            <ul>
                                {inconsistencias.map((item, index) => (
                                    <li key={index}>{item.id} | {item.centro_custo}</li>
                                ))}
                            </ul>
                        </ModalError>
                    ) : (
                        <OrganogramaContainer dados={ colabs } />
                    )
                }
            </GenericBody>
        </>
    )

}

export default ColabsOrg